import React from "react";
import {Route, Redirect} from "react-router-dom";
import AuthService from "../auth/AuthService";
import appConstants from "../appConstants";

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        AuthService.isLoggedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect
          to={{
              pathname: appConstants.NAV_URLS.LOGIN,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
export default PrivateRoute;